import React, { Component } from "react";
import UserContract from "./presenter";

class Container extends Component {
  render() {
    return <UserContract {...this.props} />;
  }
}

export default Container;
